<si-select
  class="form-control mb-8"
  multi
  hasFilter
  name="Users"
  placeholder="Name"
  [optionSource]="optionSource()"
  [ngModelOptions]="{ standalone: true }"
  [(ngModel)]="selectedItems"
/>
